var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      attrs: {
        "border-color": _vm.getStatusColor,
        "class-main": `${_vm.getBackgroundColor}`,
        "has-toggle": false,
        opened: _vm.isCancelMode
      },
      scopedSlots: _vm._u([
        {
          key: "edition",
          fn: function() {
            return [
              _c("questionnaire-cancellation", {
                on: {
                  "on-cancel": _vm.abortCancelHandler,
                  "on-save": _vm.cancelationHandler
                }
              })
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c("div", { staticClass: "row mx-auto" }, [
        _c(
          "div",
          {
            staticClass:
              "row mx-auto col-12 col-md-2 border-right align-items-center pr-5"
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex flex-column justify-content-center align-items-center"
              },
              [
                _c(
                  "div",
                  {
                    class: `badge d-flex flex-column badge-pill font-16 py-2 mt-2 w-70 color-black bg-${_vm.getStatusColor}`
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm._f("empty")(_vm.data.statusName)) + " "
                    )
                  ]
                ),
                _c("div", { staticClass: "col-12 mt-2 text-center" }, [
                  _c("div", [_vm._v(" Área: ")]),
                  _c("div", { staticClass: "color-black font-weight-bold" }, [
                    _c("img", {
                      staticClass: "pr-1 pb-1",
                      attrs: {
                        alt: "",
                        src: _vm.getImageByArea(_vm.data.areaId),
                        width: "25px"
                      }
                    }),
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("empty")(_vm.data.areaName)))
                    ])
                  ])
                ])
              ]
            )
          ]
        ),
        !_vm.isTecnicalAssistance
          ? _c("div", { staticClass: "col-12 col-md-8 pl-5" }, [
              _c("div", { staticClass: "row my-2" }, [
                _c("div", { staticClass: "col-12 col-md-6" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.isEvaluationTherapyArea
                                ? "Proveedor:"
                                : "Porteador:"
                            ) +
                            " "
                        )
                      ]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(
                        " " + _vm._s(_vm._f("empty")(_vm.serviceProvider)) + " "
                      )
                    ])
                  ])
                ]),
                _vm.isEvaluationTherapyArea
                  ? _c("div", { staticClass: "col-12 col-md-6" }, [
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "color-gray-6 d-block font-14" },
                          [_vm._v(" Lugar de Servicio: ")]
                        ),
                        _c("span", { staticClass: "font-16 color-black" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("empty")(_vm.data.locationService)
                              ) +
                              " "
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ]),
              _c("div", { staticClass: "row my-2" }, [
                _c("div", { staticClass: "col-12 col-md-3" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Semestre: ")]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(" " + _vm._s(_vm._f("empty")(_vm.semester)) + " ")
                    ])
                  ])
                ]),
                _c("div", { staticClass: "col-12 col-md-3" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Tipo de Cuestionario: ")]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(" " + _vm._s(_vm._f("empty")(_vm.type)) + " ")
                    ])
                  ])
                ]),
                _c("div", { staticClass: "col-12 col-md-3" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Disciplina: ")]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(
                        " " + _vm._s(_vm._f("empty")(_vm.data.discipline)) + " "
                      )
                    ])
                  ])
                ]),
                !_vm.isEvaluationTherapyArea
                  ? _c("div", { staticClass: "col-12 col-md-3" }, [
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "color-gray-6 d-block font-14" },
                          [_vm._v(" Tipo de Servicio: ")]
                        ),
                        _c("span", { staticClass: "font-16 color-black" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("empty")(_vm.data.serviceName)) +
                              " "
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm.isEvaluationTherapyArea
                  ? _c("div", { staticClass: "col-12 col-md-3" }, [
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "color-gray-6 d-block font-14" },
                          [_vm._v(" Nombre de Especialista: ")]
                        ),
                        _c("span", { staticClass: "font-16 color-black" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("empty")(_vm.data.specialist)) +
                              " "
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ]),
              _c("div", { staticClass: "row my-2" }, [
                !_vm.isTeacherType
                  ? _c("div", { staticClass: "col-md-3" }, [
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "color-gray-6 d-block font-14" },
                          [_vm._v(" Número SIE: ")]
                        ),
                        _c("span", { staticClass: "font-16 color-black" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("empty")(_vm.data.onlySIE)) +
                              " "
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                !_vm.isTeacherType
                  ? _c("div", { staticClass: "col-12 col-md-3" }, [
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "color-gray-6 d-block font-14" },
                          [_vm._v(" Nombre del Estudiante: ")]
                        ),
                        _c("span", { staticClass: "font-16 color-black" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("empty")(_vm.data.onlyStudentName)
                              ) +
                              " "
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                _vm.isTeacherType
                  ? _c("div", { staticClass: "col-12 col-md-3" }, [
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "color-gray-6 d-block font-14" },
                          [_vm._v(" Nombre de Maestro: ")]
                        ),
                        _c("span", { staticClass: "font-16 color-black" }, [
                          _vm._v(
                            " " +
                              _vm._s(_vm._f("empty")(_vm.data.teacher)) +
                              " "
                          )
                        ])
                      ])
                    ])
                  : _vm._e(),
                !_vm.isTeacherType
                  ? _c(
                      "div",
                      { staticClass: "col-12 col-md-5" },
                      [
                        _c(
                          "validation-observer",
                          { ref: "editableEmailObserver" },
                          [
                            _vm.isEmailEditableMode
                              ? _c(
                                  "div",
                                  { staticClass: "col-12 p-0" },
                                  [
                                    _c("validation-provider", {
                                      staticClass: "col-12 row",
                                      attrs: {
                                        "custom-messages": {
                                          required:
                                            "El correo electrónico es requerido.",
                                          email:
                                            "El correo electrónico no es válido."
                                        },
                                        rules: "required|email"
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function({ errors }) {
                                              return [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-10 row p-0"
                                                  },
                                                  [
                                                    _c("custom-input", {
                                                      staticClass: "col-12",
                                                      attrs: {
                                                        id:
                                                          "editable-email-input",
                                                        label:
                                                          "Correo Electrónico de Estudiante:"
                                                      },
                                                      model: {
                                                        value: _vm.emailInput,
                                                        callback: function(
                                                          $$v
                                                        ) {
                                                          _vm.emailInput = $$v
                                                        },
                                                        expression: "emailInput"
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "col-2 d-flex align-items-end"
                                                  },
                                                  [
                                                    _c("action-button", {
                                                      attrs: {
                                                        id:
                                                          "btn-cancel-editable-email",
                                                        i:
                                                          "fas fa-times-circle",
                                                        variant:
                                                          "outline-danger mr-2"
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.setIsEditableMode
                                                      }
                                                    }),
                                                    _c("action-button", {
                                                      attrs: {
                                                        id:
                                                          "btn-save-updated-email",
                                                        i: "fas fa-save",
                                                        variant: "success"
                                                      },
                                                      on: {
                                                        click:
                                                          _vm.onSaveUpdatedEmail
                                                      }
                                                    })
                                                  ],
                                                  1
                                                ),
                                                errors[0]
                                                  ? _c("custom-error", {
                                                      attrs: {
                                                        message: errors[0],
                                                        variant:
                                                          "no-border mt-1"
                                                      }
                                                    })
                                                  : _vm._e()
                                              ]
                                            }
                                          }
                                        ],
                                        null,
                                        false,
                                        1005632095
                                      )
                                    })
                                  ],
                                  1
                                )
                              : _c("div", { staticClass: "col-12 p-0" }, [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "color-gray-6 d-block font-14"
                                    },
                                    [
                                      _vm._v(
                                        " Correo Electrónico de Estudiante: "
                                      )
                                    ]
                                  ),
                                  _c(
                                    "span",
                                    { staticClass: "font-16 color-black" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(_vm._f("empty")(_vm.email)) +
                                          " "
                                      )
                                    ]
                                  )
                                ])
                          ]
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]),
              _vm.isCanceled && _vm.data.cancellationComment
                ? _c("div", { staticClass: "row my-2" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("div", [
                        _c(
                          "span",
                          { staticClass: "color-gray-6 d-block font-14" },
                          [_vm._v(" Comentario de Cancelación: ")]
                        ),
                        _c("span", { staticClass: "font-16 color-black" }, [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm._f("empty")(_vm.data.cancellationComment)
                              ) +
                              " "
                          )
                        ])
                      ])
                    ])
                  ])
                : _vm._e()
            ])
          : _c("div", { staticClass: "col-12 col-md-8 pl-5" }, [
              _c("div", { staticClass: "row my-2 p-4" }, [
                _c("div", { staticClass: "col-12 col-md-3" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Número de Ticket: ")]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("empty")(_vm.data.ticketNumber)) +
                          " "
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "col-12 col-md-3" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Nombre: ")]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(" " + _vm._s(_vm._f("empty")(_vm.data.name)) + " ")
                    ])
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "col-12 col-md-3" },
                  [
                    _c(
                      "validation-observer",
                      { ref: "editableEmailObserver" },
                      [
                        _vm.isEmailEditableMode
                          ? _c(
                              "div",
                              { staticClass: "col-12 p-0" },
                              [
                                _c("validation-provider", {
                                  staticClass: "col-12 row",
                                  attrs: {
                                    "custom-messages": {
                                      required:
                                        "El correo electrónico es requerido.",
                                      email:
                                        "El correo electrónico no es válido."
                                    },
                                    rules: "required|email"
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "default",
                                        fn: function({ errors }) {
                                          return [
                                            _c(
                                              "div",
                                              { staticClass: "col-10 row p-0" },
                                              [
                                                _c("custom-input", {
                                                  staticClass: "col-12",
                                                  attrs: {
                                                    id: "editable-email-input",
                                                    label: "Correo Electrónico:"
                                                  },
                                                  model: {
                                                    value: _vm.emailInput,
                                                    callback: function($$v) {
                                                      _vm.emailInput = $$v
                                                    },
                                                    expression: "emailInput"
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "col-2 d-flex align-items-end"
                                              },
                                              [
                                                _c("action-button", {
                                                  attrs: {
                                                    id:
                                                      "btn-cancel-editable-email",
                                                    i: "fas fa-times-circle",
                                                    variant:
                                                      "outline-danger mr-2"
                                                  },
                                                  on: {
                                                    click: _vm.setIsEditableMode
                                                  }
                                                }),
                                                _c("action-button", {
                                                  attrs: {
                                                    id:
                                                      "btn-save-updated-email",
                                                    i: "fas fa-save",
                                                    variant: "success"
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.onSaveUpdatedEmail
                                                  }
                                                })
                                              ],
                                              1
                                            ),
                                            errors[0]
                                              ? _c("custom-error", {
                                                  attrs: {
                                                    message: errors[0],
                                                    variant: "no-border mt-1"
                                                  }
                                                })
                                              : _vm._e()
                                          ]
                                        }
                                      }
                                    ],
                                    null,
                                    false,
                                    1700573050
                                  )
                                })
                              ],
                              1
                            )
                          : _c("div", { staticClass: "col-12 p-0" }, [
                              _c(
                                "span",
                                { staticClass: "color-gray-6 d-block font-14" },
                                [_vm._v(" Correo Electrónico: ")]
                              ),
                              _c(
                                "span",
                                { staticClass: "font-16 color-black" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm._f("empty")(_vm.email)) +
                                      " "
                                  )
                                ]
                              )
                            ])
                      ]
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "col-12 col-md-3" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Persona que trabajó el caso: ")]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("empty")(_vm.data.resolvedByName)) +
                          " "
                      )
                    ])
                  ])
                ])
              ])
            ]),
        _c(
          "div",
          { staticClass: "col-12 col-md-2 d-flex justify-content-end pr-5" },
          [
            _vm.anyVisibleAction
              ? _c("dropdown", {
                  staticClass: "mt-2",
                  attrs: {
                    id: "on-detail-btn-identifier",
                    items: _vm.actionItems,
                    title: "Acciones"
                  }
                })
              : _vm._e()
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }